import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useSwiper } from 'swiper/react'; // eslint-disable-line import/no-unresolved

export const NextButton: React.FC<{ theme?: 'black' | 'white'; children: React.ReactNode }> = ({
  theme = 'black',
  children,
}) => {
  const swiper = useSwiper();
  const [isEnd, setIsEnd] = useState(false);

  useEffect(() => {
    swiper.on('slideChange', (swipe) => {
      setIsEnd(swipe.isEnd);
    });
  }, [swiper]);

  return (
    <button
      onClick={() => swiper.slideNext()}
      disabled={isEnd}
      className={classNames('flex size-12 items-center justify-center rounded-full ring-2 ring-inset', {
        'opacity-20': isEnd,
        'ring-neutrals-black': theme === 'black',
        'ring-white': theme === 'white',
      })}
    >
      {children}
    </button>
  );
};
